import { NFLWeekAbbreviation } from '@pff-consumer/schema'

export const strIsNFLWeekAbv = (str: string): str is NFLWeekAbbreviation => {
  return Object.values(NFLWeekAbbreviation).includes(str as NFLWeekAbbreviation)
}
